import { Injectable } from '@angular/core';
import { FirebaseData } from '../../../providers/firebase-data';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Storage } from '@ionic/storage'; 
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import { AppSettings } from '../../../config/app-settings';
import { ElasticSearchService } from '../../../providers/elastic-search';
import firebase from 'firebase';

@Injectable()
export class WeeklyAdData {
    public realtimeDb: any;
    private elasticIndex: string;
    private elasticType: string;
    private elasticPath: string;
    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        private storage: Storage,
        private elasticSearchService : ElasticSearchService,
        public afw: AngularFireDatabaseWrapper,
        public settings: AppSettings,
        ) {
      this.realtimeDb = firebase.database();
      if(!this.settings.elasticSearch ||  !this.settings.elasticSearch.circularWeeklyAds || !this.settings.elasticSearch.circularWeeklyAds.index){
            this.settings.getData().subscribe(sets=>{
                this.elasticIndex = sets.elasticSearch.circularWeeklyAds.index; 
                this.elasticType = sets.elasticSearch.circularWeeklyAds.type; 
                this.elasticPath = sets.elasticSearch.circularWeeklyAds.path; 
            })
        }
        else{
            this.elasticIndex = this.settings.elasticSearch.circularWeeklyAds.index; 
            this.elasticType = this.settings.elasticSearch.circularWeeklyAds.type; 
            this.elasticPath = this.settings.elasticSearch.circularWeeklyAds.path; 
        }
    }

    public getWeeklyAdList(){
        let strgRef = FireBaseObjectNames.ONLINE_CIRCULAR_WEEKLY_ADS;
        var result = this.afw.list(strgRef).map(val => {
            return val;
        });
        return result;
    }

    public getWeeklyAds(storeId){
        var query:any = {
            index: this.elasticIndex,
            type: this.elasticType,
            size: 5000
        };
        var currentDate:any = Date.parse(new Date() + '');
        console.log(currentDate);
        query.body= {};
        query.body.query = {
            bool:{
                must:[
                    {
                        range: {
                            startDate : {
                                lte: currentDate
                            }
                        }
                    },
                    {
                        range: {
                            endDate : {
                                gte: currentDate
                            }
                        }
                    },
                    {
                        match : {
                            stores: storeId,
                    }
                }],
                must_not:[{
                     match : {
                        isDeleted: true,
                     }
                },
                // {
                //      match : {
                //         active: false,
                //      }
                // }
                ]
            }
        };
        console.log(query);
        return this.elasticSearchService.Search(query,this.elasticPath,true);
    }

    public getWeeklyAd(weeklyAdId){
        let strgRef = FireBaseObjectNames.ONLINE_CIRCULAR_WEEKLY_ADS + '/' + weeklyAdId;
        
        return this.afw.object(strgRef, undefined, true).map(weeklyAd => {
            return weeklyAd;
        });
    }

    public getCircular(circularId){
        let strgRef = FireBaseObjectNames.ONLINE_CIRCULARS + '/' + circularId;
        
        return this.afw.object(strgRef, undefined, true).map(circular => {
            return circular;
        });
    }

    // public getAllDamCategories() {
    //     let strgRef = FireBaseObjectNames.DAM_CATEGORIES;
    //     var result = this.afw.list(strgRef).map(val => {
    //         this.storage.set(strgRef, JSON.stringify(val));
    //         return val;
    //     });
    //     return result;
    // }

    // public getLocalDamProducts() {
    //     return Observable.fromPromise(this.storage.get(LocalStorageCodes.DAM_PRODUCTS))
    //         .map(val => {
    //             return val ? JSON.parse(val) : null;
    //         });
    // }

    // public getAllDamProductsFullData() {
    //     let strgRef = FireBaseObjectNames.DAM_PRODUCTS;
    //     var result = this.afw.list(strgRef).map(val => {
    //         this.storage.set(strgRef, JSON.stringify(val));
    //         return val;
    //     });
    //     return result;
    // }

    // public getDamProductsbyCatgoryData(categoryId) {
    //     // let strgRef = FireBaseObjectNames.DAM_PRODUCTS;
    //     // var result = this.afw.list(strgRef).map(val => {
    //     //     this.storage.set(strgRef, JSON.stringify(val));
    //     //     return val;
    //     // });
    //     // return result;
    // }
}


// WEBPACK FOOTER //
// ./src/modules/weekly-ad/providers/weekly-ad-data.ts